import { BusinessPartnerBody } from '../../api/generated/pap';

export enum Status {
  Active = 'active',
  Invited = 'invited',
}

export type CombinedUser = {
  name: string;
  email: string;
  businessPartner?: BusinessPartnerBody;
  businessPartnerId: string;
  id: string;
  profileIds: string[];
  createdAt: string;

  archived?: boolean; // Only exists for UserBody
  identityId?: string; // Only exists for UserBody
  status?: Status; // Only exists for InviteToJoinBody
  isOwner?: boolean; // True if this is the owner (virtual user)
};
